import {Component, Inject, OnInit, PLATFORM_ID} from '@angular/core';
import {TrackingComponent} from '@app/shared/components/tracking/tracking.component';
import {UrlService} from '@app/services/url.service';
import {FingerprintService} from '@app/services/fingerprint.service';
import {ActivatedRoute} from '@angular/router';
import {isPlatformBrowser} from '@angular/common';

@Component({
  selector: 'app-shipping-section',
  templateUrl: './shipping-section.component.html',
  styleUrls: ['./shipping-section.component.css']
})
export class ShippingSectionComponent extends TrackingComponent implements OnInit {

  constructor(private urlService: UrlService,
              private fingerprintService: FingerprintService,
              private route: ActivatedRoute,
              @Inject(PLATFORM_ID) private platformId) { super(urlService, fingerprintService, null, route, 'stu_btn_market'); }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      setTimeout(() => {
        $('#shipping-slider').owlCarousel({
          autoplay: false,
          autoplayTimeout: 7000,
          autoplayHoverPause: true,
          smartSpeed: 500,
          loop: true,
          responsiveClass: true,
          nav: false,
          navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
          margin: 20,
          dots: true,
          responsive: {
            0: {
              items: 1,
              margin: 10
            },
            576: {
              items: 1
            },
            768: {
              items: 2
            },
            992: {
              items: 2
            },
            1200: {
              items: 3
            },
            2560: {
              items: 3
            }
          }
        });
      }, 800);
    }
  }

}
